import { IconButton, Flex, MainText } from "@base-ui";
import { NavWrapper, SubNavButton, ExternalSubNavButton } from "./header.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderSubNav(_ref) {
  var id = _ref.id,
    label = _ref.label,
    entries = _ref.entries,
    closeMenu = _ref.closeMenu,
    open = _ref.open,
    setOpen = _ref.setOpen;
  return /*#__PURE__*/_jsxs("li", {
    children: [/*#__PURE__*/_jsx(ExternalSubNavButton, {
      href: "#",
      "aria-controls": id,
      iconAfter: "expandRight",
      variant: "navigation",
      onClick: function onClick(e) {
        e.preventDefault();
        document.activeElement.blur();
        setOpen(id);
      },
      "data-component": "menu-browse",
      children: label
    }), /*#__PURE__*/_jsxs(NavWrapper, {
      id: id,
      className: open === id ? "open" : "",
      zIndex: "103",
      children: [/*#__PURE__*/_jsxs(Flex.Row, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(SubNavButton, {
          to: "#",
          onClick: function onClick() {
            return setOpen("main");
          },
          iconBefore: "expandLeft",
          className: "no-border",
          "data-component": "menu-browse",
          variant: "navigation",
          children: "Tillbaka"
        }), /*#__PURE__*/_jsx(IconButton, {
          id: "close-".concat(id),
          icon: "cross",
          m: "0 0 0 auto",
          label: "St\xE4ng menyn",
          className: "no-border",
          "data-component": "menu-toggle",
          onClick: closeMenu
        })]
      }), /*#__PURE__*/_jsxs("ul", {
        children: [/*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(MainText, {
            as: "h3",
            inverted: true,
            bg: "P2",
            m: "10px 0 0",
            p: "1rem 2rem",
            fontFamily: "robotoRegular",
            children: label
          })
        }), entries.map(function (entry) {
          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(SubNavButton, {
              to: entry.to,
              variant: "navigation",
              children: entry.label
            })
          }, entry.id);
        })]
      })]
    })]
  });
}